import { LaunchModel } from './../auth/launch.model';
import { ForgotPasswordModel } from './security/forgot-password/forgot-password.model';
import { EnrollmentProgramsService } from './../shared/services/enrollment-programs.service';
import { EnrollmentRegisterModel } from './security/login-and-register/enrollee-register.model';
import { ResetPasswordModel } from './security/reset-password/reset-password.model';
import { UserModel } from './../shared/models/user-info.model';
import { APP_TOKEN_NAME, AuthService } from './../auth/auth.service';
import { AppSettings } from './../shared/app-settings';
import { Response, Http } from '@angular/http';
import { LoginModel } from './security/login-and-register/login.model';
import { Observable } from 'rxjs/Observable';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { LoadingSpinnerService } from './../shared/services/loading-spinner.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RequestForgotPasswordModel } from './security/forgot-password/request-forgot-password.model';
import { SourceDateModel } from 'app/shared/models/sourcedate.model';

@Injectable()
export class SecurityService {

  constructor(private http: HttpClient, private authService: AuthService,
    public loader: LoadingSpinnerService, public toastr: ToastsManager,
    private _enrollmentService:EnrollmentProgramsService) {
  }

  private _currentUserInfo: UserModel;

  private _programName:string;

  get currentUserInfo(): UserModel {
    return this._currentUserInfo;
  }

  moveUserToNextStage(){
    this._currentUserInfo.currentStageNumber=this._currentUserInfo.currentStageNumber++;
  }

  login(model: LoginModel): Observable<void> {
    return this.http.post<any>(AppSettings.endpoints.users.login, model).map((data) => {
      this.authService.setToken(data.token);
      this._currentUserInfo = new UserModel(data.user);
      this.currentUserInfo.isProvider = false;
      sessionStorage.setItem('isProviderAccess', `${this.currentUserInfo.isProvider}`)
      this.getSourceDate(this._currentUserInfo.id);      
    });

  }

  launch(enrolleeId:number, key:string):Observable<void>{
    let model=<LaunchModel>{
      enrolleeId:enrolleeId,
      key:key
    };
    return this.http.post<any>(AppSettings.endpoints.users.launch, model).map((data) => {
      this.authService.setToken(data.token);
      this._currentUserInfo = new UserModel(data.user); 
      this.currentUserInfo.isProvider = true;
      var isPrvKey = sessionStorage.getItem('isProviderAccess')

      if(isPrvKey == null){
        sessionStorage.setItem('isProviderAccess', `${this.currentUserInfo.isProvider}`)
      }

      this.getSourceDate(this._currentUserInfo.id);     
    });
  }

  changePassword(model: ResetPasswordModel): Observable<any> {
    return this.http.post<any>(AppSettings.endpoints.users.changePassword, model).do((data) => {
      this._currentUserInfo.isPasswordResetRequired=false;
      this.authService.setToken(data.token);
    });
  }

  logout(): Observable<any> {
    return this.http.post(AppSettings.endpoints.users.logout, {}, {
      responseType: 'text',
    }).do(() => {
      sessionStorage.clear();
      this.authService.clearToken();
      this._currentUserInfo = null;
    });
  }

  register(model: EnrollmentRegisterModel): Observable<any> {
    return this.http.post(AppSettings.endpoints.users.register, model,{
      responseType: 'text',
    });
  }

  loadUserInfo():Observable<UserModel>{
    return this.http.post<UserModel>(AppSettings.endpoints.users.userInfo,{}).do((data)=>{    
        this._currentUserInfo = data;
        this.getSourceDate(this._currentUserInfo.id);
    });
  }

  requestForgotPassword(model:RequestForgotPasswordModel):Observable<any>{
    return this.http.post(AppSettings.endpoints.users.requestForgotPassword,model,{
      responseType: 'text'
    });
  }

  forgotPasswordDoReset(model:ForgotPasswordModel):Observable<any>{
    return this.http.post(AppSettings.endpoints.users.forgotPasswordResetPassword,model,{
      responseType: 'text'
    });
  }

  forgotPasswordCheckActivationCode(code:string):Observable<boolean>{
    let url=AppSettings.formatUrl(AppSettings.endpoints.users.forgotPasswordValidateCode,code);
    return this.http.post(url,{},{
      responseType: 'text'
    }).map(()=>true).catch(()=>Observable.of(false));
  }

  private _usermodel:any;
  getSourceDate(id:number):Observable<any> { 
    let url=AppSettings.formatUrl(AppSettings.endpoints.system.sourceDate,id);    
    {
       this.http.get<SourceDateModel>(url).subscribe((data)=>{ 
        this._currentUserInfo.sourceDate = data.calculatedAgeSourceDate;
        });           
       return this._usermodel;
    }      
  }    
}




// WEBPACK FOOTER //
// ./src/app/security/security.service.ts